import TABLET_IMG from '../../../resources/images/privateAreaNavigationPage/tablet.jpg'

export { TABLET_IMG }

export const privateAreaGuideArrayPrescriptor = [
  {
    title: 'potencialData',
    description: 'potencialDataDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'potencialDataNoCups',
    description: 'potencialDataNoCupsDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'applicationWithGasSV',
    description: 'applicationPrescriptorDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2024/03/CREAR-SOLICITUD-PARA-FINCA-CON-GAS-SV-Julio-2021.pdf',
  },
  {
    title: 'certificates',
    description: 'certificatesDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2024/03/CREAR-SOLICITUD-PARA-FINCA-CON-GAS-SV-Julio-2021.pdf',
  },
  {
    title: 'campaigns',
    description: 'campaignsDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2024/03/CREAR-SOLICITUD-PARA-FINCA-CON-GAS-SV-Julio-2021.pdf',
  },
  {
    title: 'op',
    description: 'opDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'documents',
    description: 'documentsDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'states',
    description: 'statesDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'users',
    description: 'usersDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'profile',
    description: 'profileDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/MANUAL-COMPLETO-AP.pdf',
  },
  {
    title: 'privateAreaRegistration',
    description: 'privateAreaRegistrationDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2026/04/OFERTA-PUBLICA-Manual-de-registro-para-prescriptores.pdf',
  },
  {
    title: 'mobile',
    description: 'mobileDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2021/07/M%C3%B3vil-Acceder-a-mi-%C3%81rea-Privada-desde-el-M%C3%B3vil.pdf',
  },
  {
    title: 'brand',
    description: 'brandDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/09/USO-DE-LA-MARCA.pdf',
  },
  {
    title: 'ariba',
    description: 'aribaDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2026/06/Ariba-Guia-Acerca.pdf',
  },
  {
    title: 'demands',
    description: 'demandsDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2026/05/Manual-creacion-de-tarifas-y-gestion-demandas-Marketgas.pdf',
  },
]

// NEVO-439 - Limitar ACVC post portal único: se eliminan las guías temáticas de Datos del
// potencial, Solicitud (SH/SV), Certificados, Marketgas, Campañas, Presupuesto, Documentos,
// Usuario, Instalador, Gremio, Móvil, Alta Área Privada, Peticiones y Estados.
export const privateAreaGuideArray = [
  {
    title: 'op',
    description: 'opDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/OFERTA-PUBLICA-Manual-de-registro-para-la-Oferta-Pub.pdf',
  },
  {
    title: 'profile',
    description: 'profileDesc',
    url: ' https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/08/PERFIL-Recuperar-y-Cambiar-Contrasena-Editar-datos-de-Perfil.pdf',
  },
  {
    title: 'ip',
    description: 'ipDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/09/Inspecciones-realizadas-por-empresas-instaladoras.pdf',
  },
  {
    title: 'brand',
    description: 'brandDesc',
    url: 'https://www.nedgia.es/colaboradores/wp-content/uploads/sites/4/2022/09/USO-DE-LA-MARCA.pdf',
  },
  {
    title: 'ariba',
    description: 'aribaDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2026/06/Ariba-Guia-Acerca.pdf',
  },
  {
    title: 'extractEndedRequests',
    description: 'extractEndedRequestsDesc',
    url: 'https://www.nedgia.es/wp-content/uploads/2024/10/Extraccion-acumulado-puestas-en-servicio-en-area-privada-sept-2024.pdf',
  },
]
